import breads from './breads';
import cateringData from './cateringData';
import cheeses from './cheeses';
import deliBreads from './deliBreads';
import deliCheeses from './deliCheeses';
import deliCondiments from './deliCondiments';
import deliData from './deliData';
import deliFridgeItems from './deliFridgeItems';
import deliHomemadeSalads from './deliHomemadeSalads';
import deliMeats from './deliMeats';
import deliSaladPlates from './deliSaladPlates';
import deliSmokedFish from './deliSmokedFish';
import deliSoups from './deliSoups';
import deliSpecialties from './deliSpecialties';
import deliTreats from './deliTreats';
import desserts from './desserts';
import dressings from './dressings';
import drinksData from './drinksData';
import snacksData from './snacksData';
import meats from './meats';
import meatVariants from './meatVariants';
import preparations from './preparations';
import specialCombinations from './specialCombinations';
import specialtySandwichComponents from './specialtySandwichComponents';
import specialtySandwiches from './specialtySandwiches';
import styleIncludedDressings from './styleIncludedDressings';
import styleIncludedToppings from './styleIncludedToppings';
import styles from './styles';
import temperatures from './temperatures';
import toppings from './toppings';

export const dataModules = {
  breads,
  cateringData,
  cheeses,
  deliBreads,
  deliCheeses,
  deliCondiments,
  deliData,
  deliFridgeItems,
  deliHomemadeSalads,
  deliMeats,
  deliSaladPlates,
  deliSmokedFish,
  deliSoups,
  deliSpecialties,
  deliTreats,
  desserts,
  dressings,
  drinksData,
  snacksData,
  meats,
  meatVariants,
  preparations,
  specialCombinations,
  specialtySandwichComponents,
  specialtySandwiches,
  styleIncludedDressings,
  styleIncludedToppings,
  styles,
  temperatures,
  toppings,
};
